// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"iq-z","breadcrumbForward":"jq-z","breadcrumbBack":"kq-z","selected":"lq-z"};